/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';

import './ModalWithButtons.scss';

import FilePickerRow from './addMenu/FilePickerRow';
import { actions as systemModalActions } from '../../redux/ducks/systemModal';

interface Props {
  buttons: any[];
  isVisible: boolean;
  show(props): void;
  dismiss(): void;
}

const ModalButtons = (props) => {
  return props.buttons.map((b, i) => (
    (b.widget === 'file') ? (
      <FilePickerRow
        key={i}
        name="fileModal"
        accept="image/*"
        onChange={b.onSelectFile}
        rowClass="cmp-file-picker-button"
        style={{ cursor: 'pointer' }}
      >
        <div
          className={
            classnames(
              'cmp-modal-button',
              `cmp-modal-button--${b.type}`,
              `cmp-modal-button--${b.action}-action`,
              'cmp-modal-button--wide',
              {
                'profile-background-color': b.action === 'profile',
                'profile-border-color': b.action === 'profile' && b.type === 'secondary',
              }
            )
          }
        >
          {b.text}
        </div>
      </FilePickerRow>
    ) : (
      <div
        key={i}
        className={
          classnames(
            'cmp-modal-button',
            `cmp-modal-button--${b.type}`,
            `cmp-modal-button--${b.action}-action`,
            `cmp-modal-button--${b.size}`,
            'cmp-modal-button--wide',
            {
              'profile-background-color': b.action === 'profile',
              'profile-border-color': b.action === 'profile' && b.type === 'secondary',
            }
          )
        }
        onClick={b.onClick}
      >
        {b.text}
      </div>
    )
  ));
};

const ModalContent = (props) => {
  const primaryButtons = [];
  const secondaryButtons = [];

  props.buttons.map((b) => {
    if (b.type === 'primary') {
      primaryButtons.push(b);
    } else if (b.type === 'secondary') {
      secondaryButtons.push(b);
    }
    return b;
  });

  return (
    <div className="cmp-modal-footer">
      <div className="cmp-modal-button-group primary">
        <ModalButtons buttons={primaryButtons} />
      </div>
      <div className="cmp-modal-button-group secondary">
        <ModalButtons buttons={secondaryButtons} />
      </div>
    </div>
  );
}

class ModalWithButtons extends React.Component<Props> {

  componentWillReceiveProps(nextProps) {
    if (nextProps.isVisible !== this.props.isVisible) {
      if (nextProps.isVisible) {
        this.props.show(nextProps);
      } else {
        this.props.dismiss();
      }
    }
  }

  componentWillUnmount() {
    if (this.props.isVisible) {
      this.props.dismiss();
    }
  }

  render() {
    return null;
  }
}

function mapPropsToState() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    show: (props) => {
      dispatch(systemModalActions.push(
        <ModalContent buttons={props.buttons} />,
        props.options,
      ));
    },
    dismiss: () => {
      dispatch(systemModalActions.pop());
    },
  };
}

export default connect(mapPropsToState, mapDispatchToProps)(ModalWithButtons);
